import { useNavigate } from 'react-router-dom';

import {
    BellIcon,
    DotsCircleHorizontalIcon,
    HashtagIcon,
    InboxIcon,
    LogoutIcon,
    UserIcon,
    HeartIcon
} from "@heroicons/react/outline";

import { IoIosNotificationsOutline } from "react-icons/io";
import SidebarMenuItem from "./SidebarMenuItem";
import { currentBio, currentfollowers, currentfollowing, currentFullName, currentImage, currentuserId, currentusername, logOut } from "../../store/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectPostByUsername } from "../../store/postSlice";
import { useEffect } from "react";
import { useState } from "react";
import { togglenotificationbox } from "../../store/modelSlice";
import { displayNoty, resetNotification } from "../../context/profileFirebase";
import { Link } from "react-router-dom";
import { selectAllUnread } from "../../store/chatSlice";
import { auth } from '../../firebase';
import { SignpostOutlined } from '@mui/icons-material';
import { signOut } from 'firebase/auth';
import { closeFavorite, openFavorite, statusFavorites } from '../../store/favoriteSlice';

const SiderBarLeft = () => {
    const currentUserId = useSelector((state) => currentuserId(state));
    const username = useSelector((state) => currentusername(state));
    const image = useSelector((state) => currentImage(state));
    const fullName = useSelector((state) => currentFullName(state));
    const following = useSelector((state) => currentfollowing(state));
    const followers = useSelector((state) => currentfollowers(state));
    const currentbio = useSelector((state) => currentBio(state));

    const sfavorite = useSelector(statusFavorites);

    const posts = useSelector((state) => selectPostByUsername(state, currentUserId));
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const mcounter = useSelector(selectAllUnread);
    const [nCounter, setNCounter] = useState(0);
    const handleMessage = () => {

        navigate('/messages');
    }
    const handleLogOut = () => {
        dispatch(logOut());

        navigate('/signin');
    }

    const handleNotification = () => {
        dispatch(togglenotificationbox());
        resetNotification(currentUserId);
    }

    useEffect(() => {
        async function showNoti() {
            const vvount = await displayNoty(currentUserId);
            setNCounter(vvount);
        }
        currentUserId && showNoti();
    }, [currentUserId]);


    return (
        <div className="fixed left-14 w-48">
            <div className="flex flex-col h-full mt-8  ">

                {currentUserId ? (<header className="flex flex-col ml-1 ">
                    <div className='flex flex-col mx-auto justify-center items-center'>
                        <img className="h-20 w-20 rounded-full"
                            src={image ? image : "/images/default.png"}
                            loading="lazy" alt="" />
                        <div className="text-xl">
                            <Link to={`/profile/${username}`}>
                                {username}
                            </Link>
                        </div>
                        <div className="text-sm">{currentbio}</div>
                    </div>

                    <div className="flex gap-2 justify-between items-center mt-5">
                        <div className="flex flex-col items-center">
                            <div className="text-xl">{posts?.length ? posts.length : 0}</div>
                            <div className="text-xs">Posts</div>
                        </div>
                        <div className="flex flex-col items-center">
                            <div className="text-xl" >{following?.length ? following?.length : 0}</div>
                            <div className="text-xs">Following</div>
                        </div>
                        <div className="flex flex-col items-center">
                            <div className="text-xl">{followers?.length ? followers?.length : 0}</div>
                            <div className="text-xs" >Fans</div>
                        </div>
                    </div>
                </header>) : ''
                }

                {/* Menu */}

                <div className="mt-4 mb-1  w-full space-y-4">
                    {/* <SidebarMenuItem text="Feed" Icon={HomeIcon} active /> */}
                    <div
                        onClick={()=> {dispatch(closeFavorite());}}
                        className={`cursor-pointer hover:bg-gray-200  w-full   h-auto transition duration-500 ease-out flex items-start ${sfavorite ? 'text-gray-700 ': 'text-red-500 '}  justify-start  text-lg space-x-3 border-r-4 border-current`}>
                        {/* <HomeIcon className="h-7 w-7 " /> */}
                        <div className="flex gap-2">

                            <span className={`ml-1 ${sfavorite ? 'text-gray-700 ': 'text-red-500 '}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fe0707" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><g id="surface1"><path d="M 15 5 L 6.666667 5 C 6.223958 5 5.800781 5.175781 5.488281 5.488281 C 5.175781 5.800781 5 6.223958 5 6.666667 L 5 15 C 5 15.442708 5.175781 15.865885 5.488281 16.178385 C 5.800781 16.490885 6.223958 16.666667 6.666667 16.666667 L 15 16.666667 C 15.442708 16.666667 15.865885 16.490885 16.178385 16.178385 C 16.490885 15.865885 16.666667 15.442708 16.666667 15 L 16.666667 6.666667 C 16.666667 6.223958 16.490885 5.800781 16.178385 5.488281 C 15.865885 5.175781 15.442708 5 15 5 Z M 15 23.333333 L 6.666667 23.333333 C 6.223958 23.333333 5.800781 23.509115 5.488281 23.821615 C 5.175781 24.134115 5 24.557292 5 25 L 5 33.333333 C 5 33.776042 5.175781 34.199219 5.488281 34.511719 C 5.800781 34.824219 6.223958 35 6.666667 35 L 15 35 C 15.442708 35 15.865885 34.824219 16.178385 34.511719 C 16.490885 34.199219 16.666667 33.776042 16.666667 33.333333 L 16.666667 25 C 16.666667 24.557292 16.490885 24.134115 16.178385 23.821615 C 15.865885 23.509115 15.442708 23.333333 15 23.333333 Z M 33.333333 5 L 25 5 C 24.557292 5 24.134115 5.175781 23.821615 5.488281 C 23.509115 5.800781 23.333333 6.223958 23.333333 6.666667 L 23.333333 15 C 23.333333 15.442708 23.509115 15.865885 23.821615 16.178385 C 24.134115 16.490885 24.557292 16.666667 25 16.666667 L 33.333333 16.666667 C 33.776042 16.666667 34.199219 16.490885 34.511719 16.178385 C 34.824219 15.865885 35 15.442708 35 15 L 35 6.666667 C 35 6.223958 34.824219 5.800781 34.511719 5.488281 C 34.199219 5.175781 33.776042 5 33.333333 5 Z M 33.333333 23.333333 L 25 23.333333 C 24.557292 23.333333 24.134115 23.509115 23.821615 23.821615 C 23.509115 24.134115 23.333333 24.557292 23.333333 25 L 23.333333 33.333333 C 23.333333 33.776042 23.509115 34.199219 23.821615 34.511719 C 24.134115 34.824219 24.557292 35 25 35 L 33.333333 35 C 33.776042 35 34.199219 34.824219 34.511719 34.511719 C 34.824219 34.199219 35 33.776042 35 33.333333 L 35 25 C 35 24.557292 34.824219 24.134115 34.511719 23.821615 C 34.199219 23.509115 33.776042 23.333333 33.333333 23.333333 Z M 33.333333 23.333333 " transform="matrix(0.6,0,0,0.6,0,0)" />
                                </g></svg></span>
                            <span className={`inline`}>Feed</span>
                        </div>
                        {/* <span className={`inline  px-1.5 py-0.5 border-2  border-white rounded-full text-xs font-semibold   text-white`}>{ }</span> */}

                    </div>
                    {/* <SidebarMenuItem text="Explore" Icon={HashtagIcon} /> */}
                    {/* <SidebarMenuItem text="Notifications" Icon={BellIcon} /> */}
                    <div
                        onClick={handleNotification}
                        className="cursor-pointer hover:bg-gray-200 w-full  h-auto transition duration-500 ease-out flex items-start justify-between text-gray-700   text-lg space-x-3">
                        {/* <BellIcon className="h-7" /> */}
                        <div className="flex gap-2">
                            <span><IoIosNotificationsOutline className="h-7 w-7 stroke-black " stroke="2" /> </span>

                            <span className={`inline`}>Notifications</span>
                        </div>
                        {/* <span className={`inline  px-1.5 py-0.5 border-2  border-white rounded-full text-xs font-semibold  bg-red-500 text-white`}>{nCounter}</span> */}
                    </div>
                    <div
                        onClick={handleMessage}
                        className="cursor-pointer hover:bg-gray-200 w-full  h-auto transition duration-500 ease-out flex items-start justify-between text-gray-700   text-lg space-x-3">
                        {/* <BellIcon className="h-7" /> */}
                        <div className="flex gap-2">
                            <span><InboxIcon className="h-7 w-7 stroke-black " stroke="2" /> </span>

                            <span className={`inline`}>Messages</span>
                        </div>
                        {/* <span className={`inline  px-1.5 py-0.5 border-2  border-white rounded-full text-xs font-semibold  bg-red-500 text-white`}>{mcounter}</span> */}
                    </div>
                    <div
                        className="cursor-pointer hover:bg-gray-200 w-full  h-auto transition duration-500 ease-out flex items-start justify-between text-gray-700   text-lg space-x-3">
                        {/* <BellIcon className="h-7" /> */}
                        <div className="flex gap-2">

                            <span><UserIcon className="h-7 w-7 stroke-black " stroke="2" /> </span>

                            <Link to={`/profile/${username}`} className="inline" >
                                <p>Profile</p>
                            </Link>
                        </div>
                        {/* <span className={`inline  px-1.5 py-0.5 border-2  border-white rounded-full text-xs font-semibold   text-white`}>{ }</span> */}

                    </div>
                    {currentUserId ? ( <div onClick={()=> {dispatch(openFavorite());}}
                        className={`cursor-pointer hover:bg-gray-200 w-full   h-auto transition duration-500 ease-out flex items-start justify-between ${sfavorite ?'text-red-500 ' : 'text-gray-700 '}  text-lg space-x-3`}>
                        {/* <BellIcon className="h-7" /> */}
                        <div className="flex gap-2">

                            <span><HeartIcon className={`postButton h-8 w-8 ${sfavorite ?'text-red-500 ' : 'text-gray-700 '}  `}/> </span>

                            <Link to={``} className="inline" >
                                <p>Favorites</p>
                            </Link>
                        </div>
                        {/* <span className={`inline  px-1.5 py-0.5 border-2  border-white rounded-full text-xs font-semibold   text-white`}>{ }</span> */}

                    </div>):''}
                    <div
                        className="cursor-pointer hover:bg-gray-200 w-full  h-auto transition duration-500 ease-out flex items-start justify-between text-gray-700   text-lg space-x-3">
                        {/* <BellIcon className="h-7" /> */}
                        <div className="flex gap-2"
                            onClick={() => { signOut(auth); handleLogOut(); }}
                        >

                            <span><LogoutIcon className="h-7 w-7 stroke-black " stroke="2" /> </span>

                            <span className={`inline`}>Logout</span>
                        </div>
                        {/* <span className={`inline  px-1.5 py-0.5 border-2  border-white rounded-full text-xs font-semibold   text-white`}>{ }</span> */}

                    </div>
                    <div className="cursor-pointer hover:bg-gray-200 w-full  h-auto transition duration-500 ease-out flex items-start justify-between text-gray-700   text-lg space-x-3">
                        {/* <BellIcon className="h-7" /> */}
                        {/* <div className="flex gap-2">

                            <span><DotsCircleHorizontalIcon className="h-7 w-7 stroke-black " stroke="2" /> </span>

                            <span className={`inline`}>More</span>
                        </div> */}
                        {/* <span className={`inline  px-1.5 py-0.5 border-2  border-white rounded-full text-xs font-semibold   text-white`}>{ }</span> */}
                    </div>
                    {/* <SidebarMenuItem text="Messages" Icon={InboxIcon} /> */}
                    {/* <SidebarMenuItem text="Profile" Icon={UserIcon} /> */}
                    {/* <SidebarMenuItem text="More" Icon={DotsCircleHorizontalIcon} /> */}
                    {/*  */}

                </div>

                {/* Button */}

                {/* 
            <button className="bg-red-500 text-white rounded-full w-full h-12 font-bold shadow-md hover:brightness-95 text-lg  xl:inline">
                Join Creator
            </button>

 */}


            </div>
        </div>
    );
}

export default SiderBarLeft